import React from "react";
import Validate from "./Validate";

const Inputbox = (props) => {
  let newInputProps = { ...props };
  delete newInputProps["errorMsg"];
  delete newInputProps["title"];
  return (
    <div className="w-full h-full">
      <label
        htmlFor="firstname"
        className="text-darkPrimary font-[600] text-sm mb-2"
      >
        {props.title}
      </label>
      <input
        {...newInputProps}
        className={`w-full p-4  placeholder:font-Roboto focus:border-black border-[1px] border-greyLight bg-transparent  text-[1rem] text-gray-400  focus:outline-none ${props.className}`}
      />
      <Validate message={props.errorMsg} />
    </div>
  );
};

export default Inputbox;
